export default __webpack_public_path__ + "static/media/advantagemisdirection.9925f1b0.png";